import { useState } from 'react';
import Header from '../../../components/layout/Header';
import Footer from '../../../components/layout/Footer';
import WhatsAppFloat from '../../../components/ui/WhatsAppFloat';

const MentoriasPersonalizadasPage = () => {
  const [openFaq, setOpenFaq] = useState<number | null>(null);



  const mentorshipBenefits = [
    {
      icon: 'ri-user-star-line',
      title: 'Mentores Expertos',
      description: 'Acceso directo a Ariel y Fior, con más de 15 años de experiencia y $100M+ generados'
    },
    {
      icon: 'ri-target-line',
      title: 'Estrategias Personalizadas',
      description: 'Plan de acción específico para tu industria, situación y objetivos de crecimiento'
    },
    {
      icon: 'ri-team-line',
      title: 'Red de Contactos VIP',
      description: 'Acceso a nuestra red exclusiva de empresarios, inversionistas y socios estratégicos'
    },
    {
      icon: 'ri-line-chart-line',
      title: 'Crecimiento Acelerado',
      description: 'Metodologías probadas para escalar tu negocio 10x más rápido que la competencia'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Resultados Garantizados',
      description: 'Garantía de ROI o trabajamos gratis hasta que alcances tus objetivos'
    },
    {
      icon: 'ri-time-line',
      title: 'Soporte Continuo',
      description: 'Acompañamiento constante con acceso directo vía WhatsApp y sesiones de emergencia'
    }
  ];

  const mentorshipProcess = [
    {
      step: '01',
      title: 'Evaluación Inicial',
      description: 'Análisis profundo de tu negocio, finanzas y objetivos',
      icon: 'ri-search-line'
    },
    {
      step: '02',
      title: 'Plan Estratégico',
      description: 'Diseño de roadmap personalizado con metas específicas',
      icon: 'ri-map-line'
    },
    {
      step: '03',
      title: 'Implementación',
      description: 'Ejecución guiada con sesiones regulares y seguimiento',
      icon: 'ri-rocket-line'
    },
    {
      step: '04',
      title: 'Optimización',
      description: 'Ajustes continuos basados en resultados y métricas',
      icon: 'ri-settings-line'
    },
    {
      step: '05',
      title: 'Escalamiento',
      description: 'Expansión y crecimiento sostenible del negocio',
      icon: 'ri-arrow-up-line'
    }
  ];



  const faqs = [
    {
      question: '¿Qué incluye exactamente una sesión de mentoría?',
      answer: 'Cada sesión incluye revisión de progreso, análisis de desafíos actuales, estrategias específicas para tu situación, plan de acción para las próximas semanas, y acceso a recursos exclusivos. Las sesiones son completamente personalizadas según tus necesidades.'
    },
    {
      question: '¿Cómo funciona el acceso a la red de contactos?',
      answer: 'Te conectamos directamente con empresarios, inversionistas y socios estratégicos de nuestra red privada. Facilitamos introducciones calificadas, participación en eventos exclusivos, y acceso a oportunidades de inversión y partnerships.'
    },
    {
      question: '¿Qué garantías ofrecen en los resultados?',
      answer: 'Garantizamos ROI mínimo de 10x en el plan VIP, o continuamos trabajando sin costo adicional. En todos los planes, si no ves progreso significativo en los primeros 90 días, reembolsamos tu inversión.'
    },
    {
      question: '¿Puedo cambiar de plan durante la mentoría?',
      answer: 'Sí, puedes hacer upgrade a un plan superior en cualquier momento. El costo se ajusta proporcionalmente y obtienes acceso inmediato a todos los beneficios del nuevo plan.'
    },
    {
      question: '¿Qué tipo de negocios pueden beneficiarse?',
      answer: 'Trabajamos con todo tipo de negocios: startups, empresas establecidas, e-commerce, servicios profesionales, bienes raíces, y más. Nuestras estrategias se adaptan a cualquier industria y etapa de crecimiento.'
    },
    {
      question: '¿Cómo es el proceso de selección?',
      answer: 'Realizamos una evaluación inicial para asegurar que seas un buen fit. Buscamos empresarios comprometidos con el crecimiento y dispuestos a implementar las estrategias. No todos los aplicantes son aceptados.'
    }
  ];

  return (
    <div className="min-h-screen bg-black">
      <Header />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-black via-gray-900 to-black py-20 lg:py-32 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-vip-gold/10 to-transparent"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-6xl mx-auto">
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <h1 className="text-4xl lg:text-7xl font-bold text-white mb-6">
                  Mentorías <span className="bg-gradient-to-r from-vip-gold to-vip-gold-light bg-clip-text text-transparent">Personalizadas</span>
                </h1>
                <p className="text-xl lg:text-2xl text-gray-300 mb-8 leading-relaxed">
                  Acceso directo a Ariel y Fior para transformar tu negocio con estrategias probadas y resultados garantizados
                </p>

                <div className="grid grid-cols-3 gap-6 mb-8">
                  <div className="text-center">
                    <div className="text-3xl font-bold text-vip-gold mb-2">100+</div>
                    <div className="text-sm text-gray-400">Empresarios Mentoreados</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-vip-gold mb-2">$20M+</div>
                    <div className="text-sm text-gray-400">Revenue Generado</div>
                  </div>
                  <div className="text-center">
                    <div className="text-3xl font-bold text-vip-gold mb-2">5+</div>
                    <div className="text-sm text-gray-400">Años Experiencia</div>
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  <a
                    href="https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0"
                    className="bg-gradient-to-r from-vip-gold to-vip-gold-light text-black px-8 py-4 rounded-full font-bold text-lg hover:shadow-lg hover:shadow-vip-gold/30 transition-all duration-300 whitespace-nowrap text-center"
                  >
                    Aplicar Ahora
                  </a>
                  <a
                    href="https://www.skool.com/cashflow"
                    className="border-2 border-vip-gold text-vip-gold px-8 py-4 rounded-full font-bold text-lg hover:bg-vip-gold hover:text-black transition-all duration-300 whitespace-nowrap text-center"
                  >
                    Ver Comunidad
                  </a>
                </div>
              </div>

              <div className="relative">
                <img
                  src="/images/878e867da1b36d45914141269b250482.webp"
                  alt="Mentorías Personalizadas"
                  className="w-full h-auto rounded-2xl shadow-2xl"
                />
                <div className="absolute -bottom-6 -left-6 bg-vip-gold text-black p-6 rounded-2xl shadow-xl">
                  <div className="text-2xl font-bold">ROI 10x</div>
                  <div className="text-sm">Garantizado</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              ¿Por Qué Elegir Nuestras <span className="text-vip-gold">Mentorías</span>?
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Acceso exclusivo a estrategias, contactos y experiencia que han generado más de $100M en revenue
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {mentorshipBenefits.map((benefit, index) => (
              <div key={index} className="bg-gray-800 rounded-2xl p-8 shadow-lg hover:shadow-xl hover:shadow-vip-gold/20 transition-all duration-300 border border-gray-700 group">
                <div className="w-16 h-16 bg-gradient-to-br from-vip-gold to-vip-gold-light rounded-full flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300">
                  <i className={`${benefit.icon} text-2xl text-black`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-4">{benefit.title}</h3>
                <p className="text-gray-300">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Nuestro <span className="text-vip-gold">Proceso</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Metodología probada para transformar tu negocio paso a paso
            </p>
          </div>

          <div className="max-w-6xl mx-auto">
            <div className="grid md:grid-cols-5 gap-8">
              {mentorshipProcess.map((process, index) => (
                <div key={index} className="text-center group">
                  <div className="relative mb-6">
                    <div className="w-20 h-20 bg-gradient-to-br from-vip-gold to-vip-gold-light rounded-full flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                      <i className={`${process.icon} text-2xl text-black`}></i>
                    </div>
                    <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-800 text-vip-gold rounded-full flex items-center justify-center text-sm font-bold border border-gray-700">
                      {process.step}
                    </div>
                  </div>
                  <h3 className="text-xl font-bold text-white mb-3">{process.title}</h3>
                  <p className="text-gray-300 text-sm">{process.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>



      {/* FAQ Section */}
      <section className="py-20 bg-gray-900">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl lg:text-5xl font-bold text-white mb-6">
              Preguntas <span className="text-vip-gold">Frecuentes</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto">
              Resolvemos las dudas más comunes sobre nuestro programa de mentorías
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {faqs.map((faq, index) => (
              <div key={index} className="mb-4">
                <button
                  onClick={() => setOpenFaq(openFaq === index ? null : index)}
                  className="w-full bg-gray-800 border border-gray-700 rounded-lg p-6 text-left hover:border-vip-gold transition-colors duration-300"
                >
                  <div className="flex justify-between items-center">
                    <h3 className="text-lg font-bold text-white pr-4">{faq.question}</h3>
                    <i className={`ri-${openFaq === index ? 'subtract' : 'add'}-line text-vip-gold text-xl`}></i>
                  </div>
                </button>
                {openFaq === index && (
                  <div className="bg-gray-800 border-x border-b border-gray-700 rounded-b-lg p-6 -mt-1">
                    <p className="text-gray-300 leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-br from-black via-gray-900 to-black">
        <div className="container mx-auto px-6 text-center">
          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6">
            ¿Listo para <span className="bg-gradient-to-r from-vip-gold to-vip-gold-light bg-clip-text text-transparent">Acelerar</span> tu Éxito?
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Únete a los empresarios más exitosos que han transformado sus negocios con nuestras mentorías personalizadas
          </p>

          <div className="flex flex-col sm:flex-row gap-6 justify-center mb-12">
            <a
              href="https://web.cashflow.vip/widget/booking/dZafhFlPIO82YbvGywB0"
              className="bg-gradient-to-r from-vip-gold to-vip-gold-light text-black px-10 py-5 rounded-full font-bold text-xl hover:shadow-lg hover:shadow-vip-gold/30 transition-all duration-300 whitespace-nowrap"
            >
              Aplicar Ahora
            </a>
            <a
              href="https://www.skool.com/cashflow"
              className="border-2 border-vip-gold text-vip-gold px-10 py-5 rounded-full font-bold text-xl hover:bg-vip-gold hover:text-black transition-all duration-300 whitespace-nowrap"
            >
              Ver Comunidad
            </a>
          </div>

          <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            {[
              { icon: 'ri-award-line', text: 'Garantía de Resultados' },
              { icon: 'ri-vip-crown-line', text: 'Acceso VIP Exclusivo' },
              { icon: 'ri-customer-service-line', text: 'Soporte 24/7' }
            ].map((item, index) => (
              <div key={index} className="flex items-center justify-center gap-3 text-white">
                <i className={`${item.icon} text-2xl text-vip-gold`}></i>
                <span className="font-medium">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer />
      <WhatsAppFloat />
    </div>
  );
};

export default MentoriasPersonalizadasPage;